import { Skeleton } from "antd"
import cls from "classname"

import styles from "./bone.module.less"

// One skeleton block of an exact size. antd's Node takes any width and height, where Button
// clamps a min-width off its height; `block` stretches it to the container's width.
const Bone = ({ width, height, radius = 4, block, className }) => (
  <Skeleton.Node
    active
    rootClassName={cls(styles.bone, { [styles.block]: block }, className)}
    style={{ width: block ? "100%" : width, height, borderRadius: radius }}
  />
)

export default Bone
